const headings = Object.freeze({147:'Шаг 1',1180:'Шаг 3 - Столбы'});
const normalize = value => String(value || '').replace(/[\u200B-\u200D\uFEFF]/g,'').replace(/[–—]/g,'-').replace(/\s+/g,' ').trim();

// Fail closed if an editor removes or duplicates the selected section.
export function articleMiddleHeading(children, articleId) {
  const expected=headings[Number(articleId)];
  if (!expected) return null;
  const matches=Array.from(children || []).filter(node=>node.tagName==='H2' && normalize(node.textContent)===expected);
  return matches.length===1 ? matches[0] : null;
}
